module.exports = __webpack_public_path__ + "img/solution-finance-advantage1.fcb7b113.svg";